/* ============================================================
   Optilean Angebotsliste (Quote List)
   Eigenständige "Merkliste fürs Angebot" – wie ein zweiter Warenkorb.
   - localStorage-basiert (pro Browser)
   - Header-Icon + Zähler (neben dem Warenkorb)
   - Slide-in Drawer mit Positionen
   - Button "Zum Angebot hinzufügen" auf jeder Produktseite
   - Absenden -> POST an /api/cart-offers (source: 'quote-list')
   Self-contained, theme-unabhängig (liest Produktdaten via /products/<handle>.js).
   ============================================================ */
(function () {
  'use strict';

  if (window.__optileanOfferListInit) return;
  window.__optileanOfferListInit = true;

  var callbackCopy = document.currentScript && document.currentScript.dataset || {};
  var callbackLabel = callbackCopy.callbackLabel || '';
  var callbackHelp = callbackCopy.callbackHelp || '';
  var API_BASE = 'https://api.optilean.shop';
  var STORAGE_KEY = 'optilean_angebotsliste_v1';
  var CURRENCY = 'EUR';
  var FREE_SHIPPING_CENTS = 150000; // 1.500 € (netto) – versandkostenfrei

  /* ---------- State ---------- */
  function load() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    updateBadge();
    renderDrawer();
  }
  var items = load();

  function totalCount() {
    return items.reduce(function (s, i) { return s + (parseInt(i.quantity, 10) || 0); }, 0);
  }
  // Effektiver (ggf. rabattierter) Einzelpreis / Originalpreis
  function unitPrice(i) {
    return (i && i.discUnit != null) ? (parseInt(i.discUnit, 10) || 0) : (parseInt(i && i.price, 10) || 0);
  }
  function origUnit(i) {
    return (i && i.origUnit != null) ? (parseInt(i.origUnit, 10) || 0) : (parseInt(i && i.price, 10) || 0);
  }
  function totalCents() {
    return items.reduce(function (s, i) { return s + unitPrice(i) * (parseInt(i.quantity, 10) || 0); }, 0);
  }
  function origTotalCents() {
    return items.reduce(function (s, i) { return s + origUnit(i) * (parseInt(i.quantity, 10) || 0); }, 0);
  }

  /* ---------- Rabatt-Preise über den echten Warenkorb (wie Cart-Drawer) ----------
     Artikel kurz in den Shopify-Warenkorb legen, rabattierte Preise auslesen
     (App- + Automatik-Rabatte greifen nur dort) und den Warenkorb per Line-Key
     exakt wieder herstellen. Roh-Fetch -> kein UI-Flackern. */
  var repricing = false;
  var repriceTimer = null;
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function repriceFromCart(silent) {
    if (repricing || !items.length) return Promise.resolve();
    repricing = true;
    var snapByKey = {};
    return getCart().then(function (before) {
      (before.items || []).forEach(function (i) { snapByKey[i.key] = i.quantity; });
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items.map(function (i) { return { id: i.id, quantity: parseInt(i.quantity, 10) || 1 }; }) })
      });
    }).then(function () { return getCart(); }).then(function (after) {
      var priceByVariant = {};
      (after.items || []).forEach(function (i) {
        if (priceByVariant[i.id] == null) priceByVariant[i.id] = { unit: i.final_price, orig: i.original_price };
      });
      items.forEach(function (it) {
        var p = priceByVariant[it.id];
        if (p) { it.discUnit = p.unit; it.origUnit = p.orig; }
      });
      // Warenkorb exakt zurücksetzen (per Line-Key)
      var updates = {};
      (after.items || []).forEach(function (i) { updates[i.key] = snapByKey[i.key] || 0; });
      return fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }).catch(function (e) {
      console.warn('[OfferList] Rabatt-Preisermittlung fehlgeschlagen:', e);
    }).then(function () {
      repricing = false;
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
      if (!silent) renderDrawer();
    });
  }
  function repriceDebounced() {
    clearTimeout(repriceTimer);
    repriceTimer = setTimeout(repriceFromCart, 500);
  }

  /* ---------- Helpers ---------- */
  function euro(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: CURRENCY }).format(n); }
    catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(html) {
    var d = document.createElement('div');
    d.innerHTML = html.trim();
    return d.firstChild;
  }

  /* ---------- List operations ---------- */
  function addItem(item) {
    if (!item || !item.id) return;
    var ex = items.filter(function (i) { return String(i.id) === String(item.id); })[0];
    if (ex) {
      ex.quantity = (parseInt(ex.quantity, 10) || 1) + (parseInt(item.quantity, 10) || 1);
    } else {
      items.push({
        id: item.id, title: item.title || 'Artikel', variantTitle: item.variantTitle || '',
        sku: item.sku || '', handle: item.handle || '', price: parseInt(item.price, 10) || 0,
        image: item.image || '', url: item.url || '', quantity: parseInt(item.quantity, 10) || 1
      });
    }
    save(items);
    openDrawer();
    toast('Zum Angebot hinzugefügt');
  }
  function removeItem(id) {
    items = items.filter(function (i) { return String(i.id) !== String(id); });
    save(items);
  }
  function setQty(id, qty) {
    qty = parseInt(qty, 10) || 1; if (qty < 1) qty = 1;
    items.forEach(function (i) { if (String(i.id) === String(id)) i.quantity = qty; });
    save(items);
    repriceDebounced(); // Mengenstaffeln neu berechnen
  }
  function clearAll() { items = []; save(items); }
  // Leeren ohne Drawer neu zu rendern (damit die Bestätigung stehen bleibt)
  function clearSilent() {
    items = [];
    try { localStorage.setItem(STORAGE_KEY, '[]'); } catch (e) {}
    updateBadge();
  }

  var CHECK_ICON =
    '<svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="#1a8a4a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="10"/><path d="M8 12.5l2.5 2.5 5-5.5"/></svg>';

  function showConfirmation(email, sent) {
    var body = document.getElementById('opf-body');
    var foot = document.getElementById('opf-foot');
    if (body) {
      body.innerHTML =
        '<div class="opf-success">' + CHECK_ICON +
          '<h3>' + (sent ? 'Angebot versendet!' : 'Angebot erstellt!') + '</h3>' +
          (sent
            ? '<p>Wir haben dir dein PDF-Angebot an <strong>' + esc(email) + '</strong> geschickt.</p>' +
              '<p class="opf-success__hint">Schau ggf. auch im Spam-Ordner nach.</p>'
            : '<p>Dein Angebot wurde erstellt. Wir melden uns in Kürze bei dir unter <strong>' + esc(email) + '</strong>.</p>') +
        '</div>';
    }
    if (foot) {
      foot.innerHTML = '<button type="button" class="opf-submit" id="opf-done">Fertig</button>';
      var done = foot.querySelector('#opf-done');
      if (done) done.addEventListener('click', closeDrawer);
    }
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('opf-toast');
    if (!t) { t = el('<div id="opf-toast" class="opf-toast"></div>'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('opf-toast--show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('opf-toast--show'); }, 2200);
  }

  /* ---------- Header icon + badge ---------- */
  var LIST_ICON =
    '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M14.5 3H7.5A1.5 1.5 0 0 0 6 4.5v15A1.5 1.5 0 0 0 7.5 21h9A1.5 1.5 0 0 0 18 19.5V6.5z"/>' +
    '<path d="M14.5 3v2.5a1 1 0 0 0 1 1H18"/>' +
    '<circle cx="9.3" cy="11" r="1" fill="currentColor" stroke="none"/><line x1="11.7" y1="11" x2="15.4" y2="11"/>' +
    '<circle cx="9.3" cy="14" r="1" fill="currentColor" stroke="none"/><line x1="11.7" y1="14" x2="15.4" y2="14"/>' +
    '<circle cx="9.3" cy="17" r="1" fill="currentColor" stroke="none"/><line x1="11.7" y1="17" x2="15.4" y2="17"/></svg>';

  function buildHeaderButton() {
    if (document.getElementById('opf-header-btn')) return true;
    // Den Warenkorb-LINK (<a>) finden – NICHT das Bubble-Div darin.
    var cartLink =
      document.querySelector('header a[href$="/cart"], header a[href*="/cart"]') ||
      document.querySelector('.header__icons a[href$="/cart"], .header__icons a[href*="/cart"]') ||
      document.querySelector('a[href$="/cart"], a[href*="/cart"]');
    if (!cartLink) {
      // Fallback: vom Bubble-Div zum umschließenden <a> hochgehen
      var bubble = document.querySelector('#cart-icon-bubble');
      if (bubble && bubble.closest) cartLink = bubble.closest('a');
    }
    if (!cartLink || !cartLink.parentNode) return false;

    var container = cartLink.parentNode; // die Icon-Gruppe im Header
    var btn = el(
      '<a href="#" id="opf-header-btn" class="opf-header-btn header__icon has-motion relative text-current" aria-label="Angebotsliste" title="Angebotsliste">' +
      LIST_ICON + '<span class="opf-badge" id="opf-badge" hidden>0</span></a>'
    );
    btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    // In die Mitte: VOR den Warenkorb (Reihenfolge: Konto · Angebotsliste · Warenkorb).
    container.insertBefore(btn, cartLink);
    updateBadge();
    return true;
  }

  function updateBadge() {
    var b = document.getElementById('opf-badge');
    if (!b) return;
    var c = totalCount();
    b.textContent = c;
    if (c > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
  }

  /* ---------- Drawer ---------- */
  function buildDrawer() {
    if (document.getElementById('opf-drawer')) return;
    var overlay = el('<div id="opf-overlay" class="opf-overlay"></div>');
    overlay.addEventListener('click', closeDrawer);
    var drawer = el(
      '<aside id="opf-drawer" class="opf-drawer" aria-hidden="true" aria-label="Angebotsliste">' +
        '<div class="opf-drawer__head">' +
          '<span class="opf-drawer__title">Angebotsliste</span>' +
          '<button type="button" class="opf-x" id="opf-close" aria-label="Schließen">&times;</button>' +
        '</div>' +
        '<div class="opf-drawer__body" id="opf-body"></div>' +
        '<div class="opf-drawer__foot" id="opf-foot"></div>' +
      '</aside>'
    );
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    drawer.querySelector('#opf-close').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    renderDrawer();
  }

  function renderDrawer() {
    var body = document.getElementById('opf-body');
    var foot = document.getElementById('opf-foot');
    if (!body || !foot) return;

    if (!items.length) {
      body.innerHTML = '<div class="opf-empty">Deine Angebotsliste ist leer.<br><span>Füge Produkte über „Zum Angebot hinzufügen" hinzu.</span></div>';
      foot.innerHTML = '';
      return;
    }

    body.innerHTML = shippingBarHtml() + items.map(function (i) {
      var qtyN = parseInt(i.quantity, 10) || 1;
      var u = unitPrice(i), o = origUnit(i);
      var line = u * qtyN;
      var hasDisc = o > u;
      var priceCell = hasDisc
        ? '<span class="opf-item__orig">' + euro(o * qtyN) + '</span> <span class="opf-item__price opf-item__price--disc">' + euro(line) + '</span>'
        : '<span class="opf-item__price">' + euro(line) + '</span>';
      return '' +
        '<div class="opf-item" data-id="' + esc(i.id) + '">' +
          '<div class="opf-item__img">' + (i.image ? '<img src="' + esc(i.image) + '" alt="">' : '') + '</div>' +
          '<div class="opf-item__main">' +
            '<a class="opf-item__title" href="' + esc(i.url || '#') + '">' + esc(i.title) + '</a>' +
            (i.variantTitle ? '<div class="opf-item__var">' + esc(i.variantTitle) + '</div>' : '') +
            (i.sku ? '<div class="opf-item__sku">Art.-Nr.: ' + esc(i.sku) + '</div>' : '') +
            '<div class="opf-item__row">' +
              '<div class="opf-qty">' +
                '<button type="button" class="opf-qty__btn" data-act="dec">&minus;</button>' +
                '<input class="opf-qty__in" type="number" min="1" value="' + (parseInt(i.quantity, 10) || 1) + '">' +
                '<button type="button" class="opf-qty__btn" data-act="inc">+</button>' +
              '</div>' +
              priceCell +
            '</div>' +
          '</div>' +
          '<button type="button" class="opf-item__rm" data-act="rm" aria-label="Entfernen">&times;</button>' +
        '</div>';
    }).join('');

    // Item-Events
    body.querySelectorAll('.opf-item').forEach(function (row) {
      var id = row.getAttribute('data-id');
      row.querySelector('[data-act="rm"]').addEventListener('click', function () { removeItem(id); });
      row.querySelector('[data-act="inc"]').addEventListener('click', function () { setQty(id, (curQty(id) + 1)); });
      row.querySelector('[data-act="dec"]').addEventListener('click', function () { setQty(id, (curQty(id) - 1)); });
      var input = row.querySelector('.opf-qty__in');
      input.addEventListener('change', function () { setQty(id, input.value); });
    });

    // bestehende Eingaben sichern (Re-Render z.B. nach Repricing soll nichts löschen)
    var prevName = (document.getElementById('opf-name') || {}).value || '';
    var prevEmail = (document.getElementById('opf-email') || {}).value || '';
    var prevPhone = (document.getElementById('opf-phone') || {}).value || '';
    var prevNote = (document.getElementById('opf-note') || {}).value || '';

    foot.innerHTML =
      '<div class="opf-total"><span>Summe (netto)</span><strong>' + euro(totalCents()) + '</strong></div>' +
      '<button type="button" class="opf-cart-btn" id="opf-to-cart">In den Warenkorb legen</button>' +
      '<form id="opf-form" class="opf-form" novalidate>' +
        '<input type="text" id="opf-name" class="opf-input" placeholder="Name (optional)" autocomplete="name">' +
        '<input type="email" id="opf-email" class="opf-input" placeholder="E-Mail-Adresse*" autocomplete="email" required>' +
        '<label for="opf-phone">' + esc(callbackLabel) + '</label>' +
        '<input type="tel" inputmode="tel" maxlength="60" id="opf-phone" class="opf-input" autocomplete="tel" aria-describedby="opf-phone-help">' +
        '<small id="opf-phone-help">' + esc(callbackHelp) + '</small>' +
        '<textarea id="opf-note" class="opf-input opf-note" placeholder="Anmerkung (optional)" rows="2"></textarea>' +
        '<button type="submit" class="opf-submit" id="opf-submit">Angebot als PDF anfordern</button>' +
        '<div class="opf-msg" id="opf-msg"></div>' +
        '<button type="button" class="opf-clear" id="opf-clear">Liste leeren</button>' +
      '</form>';

    foot.querySelector('#opf-name').value = prevName;
    foot.querySelector('#opf-email').value = prevEmail;
    foot.querySelector('#opf-phone').value = prevPhone;
    foot.querySelector('#opf-note').value = prevNote;
    var toCartBtn = foot.querySelector('#opf-to-cart');
    if (toCartBtn) toCartBtn.addEventListener('click', addAllToCart);
    foot.querySelector('#opf-clear').addEventListener('click', function () {
      if (confirm('Angebotsliste wirklich leeren?')) clearAll();
    });
    foot.querySelector('#opf-form').addEventListener('submit', submitOffer);
  }

  function shippingBarHtml() {
    var total = totalCents();
    var remaining = FREE_SHIPPING_CENTS - total;
    var pct = Math.min(100, Math.round((total / FREE_SHIPPING_CENTS) * 100));
    var reached = remaining <= 0;
    return '' +
      '<div class="opf-ship">' +
        '<div class="opf-ship__text">' +
          (reached
            ? '🎉 <strong>Geschafft – versandkostenfrei!</strong>'
            : 'Noch <strong>' + euro(remaining) + '</strong> bis zum kostenlosen Versand.') +
        '</div>' +
        '<div class="opf-ship__sub">Ab 1.500 € liefern wir versandkostenfrei.</div>' +
        '<div class="opf-ship__bar"><div class="opf-ship__fill' + (reached ? ' opf-ship__fill--full' : '') + '" style="width:' + pct + '%"></div></div>' +
      '</div>';
  }

  function curQty(id) {
    var it = items.filter(function (i) { return String(i.id) === String(id); })[0];
    return it ? (parseInt(it.quantity, 10) || 1) : 1;
  }

  // Alle Positionen der Angebotsliste in den echten Shopify-Warenkorb legen.
  function addAllToCart() {
    if (!items.length) return;
    var btn = document.getElementById('opf-to-cart');
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt …'; }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.map(function (i) { return { id: i.id, quantity: parseInt(i.quantity, 10) || 1 }; }) })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || ('HTTP ' + r.status)); });
      return r.json();
    }).then(function () {
      window.location.href = '/cart'; // zum Warenkorb (zeigt Rabatte/Mengenstaffeln)
    }).catch(function (e) {
      if (btn) { btn.disabled = false; btn.textContent = 'In den Warenkorb legen'; }
      toast('Konnte nicht in den Warenkorb legen: ' + e.message);
    });
  }

  // Sticky-Kontakt (#sticky-kontakt) ausblenden, wenn unser Drawer ODER der Warenkorb-Drawer offen ist.
  function isMyDrawerOpen() {
    var d = document.getElementById('opf-drawer');
    return !!(d && d.classList.contains('opf-drawer--open'));
  }
  function isCartDrawerOpen() {
    var c = document.getElementById('cart-drawer');
    return !!(c && (c.hasAttribute('open') || c.getAttribute('aria-hidden') === 'false'));
  }
  function updateContactVisibility() {
    var hide = isMyDrawerOpen() || isCartDrawerOpen();
    document.body.classList.toggle('opf-hide-contact', hide);
  }

  function openDrawer() {
    buildDrawer();
    renderDrawer(); // immer den aktuellen Stand anzeigen (z.B. nach Bestätigung)
    document.getElementById('opf-overlay').classList.add('opf-overlay--show');
    var d = document.getElementById('opf-drawer');
    d.classList.add('opf-drawer--open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    updateContactVisibility();
    repriceFromCart(); // rabattierte Preise aus dem echten Warenkorb holen
  }
  function closeDrawer() {
    var ov = document.getElementById('opf-overlay');
    var d = document.getElementById('opf-drawer');
    if (ov) ov.classList.remove('opf-overlay--show');
    if (d) { d.classList.remove('opf-drawer--open'); d.setAttribute('aria-hidden', 'true'); }
    document.documentElement.style.overflow = '';
    updateContactVisibility();
  }

  /* ---------- Submit ---------- */
  function submitOffer(e) {
    e.preventDefault();
    var emailEl = document.getElementById('opf-email');
    var msg = document.getElementById('opf-msg');
    var btn = document.getElementById('opf-submit');
    var email = (emailEl.value || '').trim();
    msg.className = 'opf-msg';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Bitte eine gültige E-Mail-Adresse eingeben.';
      msg.classList.add('opf-msg--err'); emailEl.focus(); return;
    }
    if (!items.length) { return; }

    var name = (document.getElementById('opf-name').value || '').trim();
    var phone = (document.getElementById('opf-phone').value || '').trim();
    var note = (document.getElementById('opf-note').value || '').trim();

    function buildPayload() {
      return {
        email: email,
        currency: CURRENCY,
        source: 'quote-list',
        sourceUrl: location.href,
        name: name,
        phone: phone,
        callbackRequested: Boolean(phone),
        note: note,
        totalPrice: totalCents(),
        originalTotalPrice: origTotalCents(),
        totalDiscount: Math.max(0, origTotalCents() - totalCents()),
        items: items.map(function (i) {
          var qty = parseInt(i.quantity, 10) || 1;
          var unit = unitPrice(i);
          var orig = origUnit(i);
          return {
            variantId: i.id, title: i.title, variantTitle: i.variantTitle, sku: i.sku, handle: i.handle,
            quantity: qty,
            price: unit, linePrice: unit * qty,
            originalPrice: orig, originalLinePrice: orig * qty,
            totalDiscount: Math.max(0, (orig - unit) * qty),
            imageUrl: i.image,
            properties: name || note ? [].concat(
              name ? [{ name: 'Name', value: name }] : [],
              note ? [{ name: 'Anmerkung', value: note }] : []
            ) : []
          };
        })
      };
    }

    btn.disabled = true; btn.textContent = 'Wird berechnet …';
    clearTimeout(repriceTimer);
    repriceFromCart(true).then(function () {
      btn.textContent = 'Wird gesendet …';
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      return fetch(root + 'apps/address-book/offer-context', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
        if (!r.ok) throw new Error('Deine Anmeldung konnte nicht geprüft werden. Bitte lade die Seite neu.');
        return r.json();
      }).then(function (context) {
        if (!context.customerContext) throw new Error('Deine Anmeldung konnte nicht geprüft werden. Bitte lade die Seite neu.');
        var payload = buildPayload();
        payload.customerContext = context.customerContext;
        return fetch(API_BASE + '/api/cart-offers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
        });
      });
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok && (res.j.emailStatus === 'email_sent')) {
          showConfirmation(email, true);   // Liste bleibt erhalten
        } else if (res.ok) {
          showConfirmation(email, false);  // Liste bleibt erhalten
        } else {
          throw new Error(res.j && res.j.message ? res.j.message : 'Fehler');
        }
      }).catch(function (err) {
        msg.textContent = 'Fehler: ' + err.message;
        msg.classList.add('opf-msg--err');
      }).then(function () {
        btn.disabled = false; btn.textContent = 'Angebot als PDF anfordern';
      });
  }

  /* ---------- PDP button ---------- */
  function findAddToCartButton() {
    // Echten "In den Warenkorb"-Button finden (nicht das Raten-/Instalments-Formular).
    var byName = Array.prototype.slice.call(document.querySelectorAll('[name="add"]'))
      .filter(function (b) { return b.closest('form[action*="/cart/add"]'); })[0];
    if (byName) return byName;
    // Fallback: Submit-Button mit passendem Text
    var subs = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"] [type="submit"], product-form button[type="submit"]'));
    var byText = subs.filter(function (b) { return /warenkorb|in den korb|add to cart/i.test((b.innerText || b.value || '')); })[0];
    return byText || subs[subs.length - 1] || null;
  }

  function buildPdpButton() {
    if (document.getElementById('opf-pdp-btn')) return;
    var handleMatch = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!handleMatch) return; // keine Produktseite
    var handle = handleMatch[1];

    var addBtn = findAddToCartButton();
    if (!addBtn) return;
    var form = addBtn.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    // Enge "In den Warenkorb"-Zeile als Bezug -> meinen Button direkt DARUNTER.
    var container =
      addBtn.closest('.product-form__buttons') ||
      addBtn.closest('.product-info__add-to-cart') ||
      addBtn.closest('.product-info__add-button') ||
      addBtn.parentNode;
    if (!container || !container.parentNode) return;

    var btn = el('<button type="button" id="opf-pdp-btn" class="opf-pdp-btn">' + LIST_ICON + '<span>Zum Angebot hinzufügen</span></button>');
    btn.addEventListener('click', function () {
      var variantId = (((form && form.querySelector('[name="id"]')) || {}).value) || '';
      var qtyEl = (form && form.querySelector('[name="quantity"]')) || document.querySelector('[name="quantity"]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      btn.disabled = true;
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var v = (p.variants || []).filter(function (x) { return String(x.id) === String(variantId); })[0] || (p.variants || [])[0] || {};
          var img = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
          addItem({
            id: v.id || p.id, title: p.title,
            variantTitle: (v.title && v.title !== 'Default Title') ? v.title : '',
            sku: v.sku || '', handle: handle, price: v.price != null ? v.price : p.price,
            image: img, url: '/products/' + handle + (v.id ? ('?variant=' + v.id) : ''),
            quantity: qty
          });
        }).catch(function () {
          // Fallback ohne AJAX-Daten
          addItem({ id: variantId || handle, title: document.title.replace(/\s*[–|].*$/, ''), handle: handle, price: 0, quantity: qty, url: location.pathname });
        }).then(function () { btn.disabled = false; });
    });

    // Direkt UNTER den Kauf-Buttons einfügen
    container.parentNode.insertBefore(btn, container.nextSibling);
  }

  /* ---------- Boot ---------- */
  function boot() {
    buildDrawer();
    var okHeader = buildHeaderButton();
    buildPdpButton();
    updateBadge();

    // Warenkorb-Drawer beobachten -> Sticky-Kontakt mit aus-/einblenden
    var cartEl = document.getElementById('cart-drawer');
    if (cartEl) {
      new MutationObserver(updateContactVisibility)
        .observe(cartEl, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden', 'style'] });
    }
    updateContactVisibility();

    // Header/PDP können verzögert/asynchron gerendert werden -> kurz nachbeobachten
    if (!okHeader || (location.pathname.indexOf('/products/') !== -1 && !document.getElementById('opf-pdp-btn'))) {
      var tries = 0;
      var obs = new MutationObserver(function () {
        if (!document.getElementById('opf-header-btn')) buildHeaderButton();
        if (location.pathname.indexOf('/products/') !== -1) buildPdpButton();
        if ((document.getElementById('opf-header-btn')) && (location.pathname.indexOf('/products/') === -1 || document.getElementById('opf-pdp-btn'))) {
          obs.disconnect();
        }
        if (++tries > 60) obs.disconnect();
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Öffentliche API
  window.OptileanOfferList = {
    add: addItem, remove: removeItem, setQty: setQty, clear: clearAll,
    open: openDrawer, close: closeDrawer, count: totalCount, items: function () { return items.slice(); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
